import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

function required(name: string): string {
  const v = import.meta.env[name as keyof ImportMetaEnv] as string | undefined;
  if (!v) throw new Error(`環境変数 ${name} が未設定です。web/.env.example を参照してください。`);
  return v;
}

// Google ログインの中継ページ（/__/auth/handler）は、画面と同じドメインで開く。
// 別ドメイン（firebaseapp.com）で開くと、ストレージを分けるブラウザ（Android の一部・
// アプリ内ブラウザ等）で "missing initial state" になりログインできない。
// Firebase Hosting はどのドメインでも /__/auth/handler を配るので、本番は開いているドメインを使う。
// ローカル（vite・エミュレータ）では中継ページが無いので .env の値を使う。
// 前提: OAuth クライアントの承認済みリダイレクト URI に各ドメインの /__/auth/handler を登録済みであること。
const HOSTED_AUTH_DOMAINS = ["app.ichininmae.jp", "sakama-recipe-sop.web.app", "sakama-recipe-sop.firebaseapp.com"];
const authDomain = HOSTED_AUTH_DOMAINS.includes(window.location.hostname)
  ? window.location.hostname
  : required("VITE_FIREBASE_AUTH_DOMAIN");

export const app = initializeApp({
  apiKey: required("VITE_FIREBASE_API_KEY"),
  authDomain,
  projectId: required("VITE_FIREBASE_PROJECT_ID"),
  storageBucket: required("VITE_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: required("VITE_FIREBASE_MESSAGING_SENDER_ID"),
  appId: required("VITE_FIREBASE_APP_ID"),
});

export const auth = getAuth(app);
export const db = getFirestore(app);

// 動画は既存の GCS バケット(analyze が使うのと同じ)へ入れる。
// バケットを分けると「CLI が読む場所」と「画面が書く場所」がズレるため。
export const storage = getStorage(app, `gs://${required("VITE_FIREBASE_STORAGE_BUCKET")}`);

// ローカルの画面操作テスト（`npm run dev:emulator`）。ポートは firebase.local.json と揃える。
// 本番のビルドでは VITE_USE_EMULATORS が無いので何もしない。
// Functions は画面の各所が getFunctions(app, region) で個別に取るが、同じ region なら
// 同じインスタンスが返るので、ここで1回つなげば全部に効く
if (import.meta.env.VITE_USE_EMULATORS === "1") {
  connectAuthEmulator(auth, "http://127.0.0.1:9098", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8181);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  connectFunctionsEmulator(getFunctions(app, "asia-northeast1"), "127.0.0.1", 5001);
}
